// Import from libraries
import type { TdHTMLAttributes } from 'react'
import { useRouteContext, useLoaderData } from '@tanstack/react-router'
import { BsDownload, BsCheckCircleFill, BsClock } from 'react-icons/bs'

// Import from scripts
import { fetchAuthenticated } from '@/queries/shared'
import { type ExtractRequest } from '@/models/extract'

// Import components
import { DownloadBlob } from '@/components/components'
import { stripAriaSelected } from '@/components/shared/tables/KendoTableClientState/kendo-cell-utils'

export default function ExtractStatusCell(
    extract: ExtractRequest,
    tdProps?: TdHTMLAttributes<HTMLTableCellElement> | null,
    downloadPathPrefix: string = '/extracts'
) {
    const cleanTdProps = stripAriaSelected(tdProps);
    const globalState = useLoaderData({ from: "__root__" })
    const currentUserOrg = useRouteContext({ from: '/$leaid' }).currentUserOrg;

    const downloadExtract = async (extractRequestId: number, extractName: string) => {
        const extractData = await fetchAuthenticated(globalState, `${downloadPathPrefix}/${currentUserOrg.esiIdPath}/${extractRequestId}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })
        DownloadBlob(await extractData.blob(), extractName);
    }
    
    const value = extract['ExtractStatus'];

    switch (value) {
        case "Complete":
            return (
                <td {...cleanTdProps}>
                    <div className="d-flex align-items-center gap-3">
                        <span className="d-flex align-items-center gap-1" style={{ color: 'var(--status-success)', whiteSpace: 'nowrap' }}>
                            <BsCheckCircleFill size={14} aria-hidden="true" />
                            {value}
                        </span>
                        <button
                            type="button"
                            className="btn btn-link p-0"
                            title="Download"
                            aria-label="Download extract"
                            style={{ color: "#0f172a", lineHeight: 1 }}
                            onClick={() => {
                                downloadExtract(extract['ExtractRequestId'], extract['FileName'])
                                    .catch((error) => {console.error("Error downloading extract:", error)});
                            }}
                        >
                            <BsDownload size={18} aria-hidden="true" />
                        </button>
                    </div>
                </td>
            )
        case "Request Raised":
            return (
                <td {...cleanTdProps}>
                    <span className="d-flex align-items-center gap-1" style={{ color: 'var(--status-warning)', whiteSpace: 'nowrap' }}>
                        <BsClock size={14} aria-hidden="true" />
                        {value}
                    </span>
                </td>
            )
        default:
            return (
                <td {...cleanTdProps} style={{ ...cleanTdProps?.style, color: 'var(--status-default)' }}>
                    {value}
                </td>
            )
    }
}